module.exports = __webpack_public_path__ + "d308073b/img/cadBim.e369a02a.png";